import { createApiClient, createCentralApi } from '@zcmss/api-client';

const TOKEN_KEY = 'zcmss-admin-portal-token';

function getToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(TOKEN_KEY);
}

export const apiClient = createApiClient({
  baseUrl: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000/api/v1',
  getToken,
  onUnauthorized: () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(TOKEN_KEY);
      document.cookie = `${TOKEN_KEY}=; path=/; max-age=0`;
      window.location.href = '/login';
    }
  },
});

export const api = createCentralApi(apiClient);

export { TOKEN_KEY };
